import { getAttributionQueryString } from './attribution';

export const COMPLETION_THRESHOLD = 0.8; // 80% czasu trwania lekcji

export const APP_SUBDOMAIN = 'app.forumkapitalu.pl';

/**
 * Ścieżki panelu (AppPlatform) — lokalnie na localhost oraz na subdomenie app.* w produkcji.
 * Na marketingowej domenie (forumkapitalu.pl) przekierowujemy na app.*.
 */
export const APP_PLATFORM_PATH_PATTERN =
  /^\/(login|register|forgot-password|dashboard|strona-glowna|kursy|zapisy-live|aktualnosci|narzedzia|course\/|lesson\/|billing|activate|auth\/complete-signup|auth\/reset-password|auth\/nowe-haslo|ustawienia|konto|regulamin|polityka-prywatnosci|discord\/link-callback)/;

/** Pełny URL na subdomenie app z zachowaniem ścieżki, query i hash. */
export function getAppSubdomainAbsoluteUrl(pathname?: string): string {
  if (typeof window === 'undefined') {
    return `https://${APP_SUBDOMAIN}/`;
  }
  const path = (pathname ?? window.location.pathname) || '/';
  const { search, hash } = window.location;
  return `https://${APP_SUBDOMAIN}${path}${search}${hash}`;
}

export function isAppPlatformPath(pathname: string): boolean {
  return APP_PLATFORM_PATH_PATTERN.test(pathname);
}

/**
 * Publiczna strona główna (marketing) — używana po wylogowaniu z panelu na subdomenie app.*.
 * Ustaw w `.env`, jeśli domena inna niż domyślna.
 */
export function getLogoutLandingUrl(): string {
  if (typeof window === 'undefined') return '/';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return '/';
  }
  if (host === APP_SUBDOMAIN || host.startsWith('app.')) {
    const fromEnv = process.env.REACT_APP_MAIN_SITE_URL?.trim();
    if (fromEnv) return fromEnv.replace(/\/$/, '');
    return 'https://forumkapitalu.pl';
  }
  return '/';
}

/**
 * Domyślne wejście do panelu po logowaniu.
 * Na localhost `/` to landing (MainSite w App.tsx) — nie używaj go jako celu po auth.
 */
export const APP_ENTRY_PATH = '/strona-glowna';

/** E-mail wsparcia użytkowników panelu (np. menu boczne „Support”). */
export const APP_SUPPORT_EMAIL = 'kontakt@forumkapitalu.pl';

/** Link do logowania w panelu (subdomena app.*); z marketingu przekierowuje na /login aplikacji. */
export function getAppPanelLoginUrl(): string {
  if (typeof window === 'undefined') {
    return '/login';
  }
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return '/login';
  }
  if (host === APP_SUBDOMAIN || host.startsWith('app.')) {
    return '/login';
  }
  return `https://${APP_SUBDOMAIN}/login`;
}

/**
 * Cel `redirectTo` dla linku resetu hasła z maila (Supabase Auth / Edge).
 * Dodaj w Supabase: Authentication → URL configuration → Redirect URLs
 * (np. `https://app.forumkapitalu.pl/auth/nowe-haslo` i `http://localhost:3000/auth/nowe-haslo`).
 */
export function getPasswordRecoveryRedirectUrl(): string {
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}/auth/nowe-haslo`;
}

/** Checkout Stripe na panelu (gość) — zachowuje UTM z filmiku / reflinka. */
export function getAppBillingUrl(): string {
  const attributionQuery = getAttributionQueryString();

  if (typeof window === 'undefined') {
    return `/billing${attributionQuery}`;
  }
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return `/billing${attributionQuery}`;
  }
  if (host === APP_SUBDOMAIN || host.startsWith('app.')) {
    return `/billing${attributionQuery}`;
  }
  return `https://${APP_SUBDOMAIN}/billing${attributionQuery}`;
}

